// ─────────────────────────────────────────────────────────────────────────────
// Six portal entry-points — visual configuration.
// Used by /login/:portal pages and the Mega-Menu Login dropdown.
// ─────────────────────────────────────────────────────────────────────────────

export const PORTALS = {
  'platform-owner': {
    slug: 'platform-owner',
    label_en: 'Platform Owner',
    label_ar: 'مالك المنصّة',
    tagline_en: 'Global control plane — organizations, subscriptions, audit, governance.',
    tagline_ar: 'مركز التحكّم الشامل — المؤسسات والاشتراكات والتدقيق والحوكمة.',
    accent: '#D4AF37',          // sovereign gold
    bg: '#0A0A0F',              // obsidian base
    panel: '#000000',           // pure obsidian
    panelTextOn: '#F5E6B3',     // soft gold text
    auth: { password: true, magicLink: false, otp: false },  // password-only for safety
    afterLogin: '/platform',
    badge_en: 'Sovereign',
    badge_ar: 'سيادي',
  },
  manager: {
    slug: 'manager',
    label_en: 'Property Manager',
    label_ar: 'مدير العقارات',
    tagline_en: 'Operate every portfolio, building, and team — from one platform.',
    tagline_ar: 'شغّل كل محفظة وعمارة وفريق من منصّة واحدة.',
    accent: '#00734A',          // emerald — enterprise-operations green
    bg: '#FBFCFD',
    panel: '#0E1320',           // navy left panel
    panelTextOn: '#FFFFFF',
    auth: { password: true, magicLink: true, otp: false },
    afterLogin: '/dashboard',
    badge_en: 'Operations',
    badge_ar: 'تشغيل',
  },
  'investment-manager': {
    slug: 'investment-manager',
    label_en: 'Investment Manager',
    label_ar: 'مدير الاستثمار',
    tagline_en: 'Institutional reporting · capital performance · fund analytics.',
    tagline_ar: 'تقارير مؤسّسيّة · أداء رأس المال · تحليلات الصناديق.',
    accent: '#1E3A5F',          // financial navy
    bg: '#F4F6F9',
    panel: '#0B1F3D',           // deep institutional navy
    panelTextOn: '#FFFFFF',
    auth: { password: true, magicLink: true, otp: false },
    afterLogin: '/dashboard',
    badge_en: 'Capital',
    badge_ar: 'رأس المال',
  },
  resident: {
    slug: 'resident',
    label_en: 'Resident · Tenant',
    label_ar: 'المستأجر',
    tagline_en: 'Pay rent · raise tickets · access manuals — anywhere, anytime.',
    tagline_ar: 'ادفع الإيجار · أرسل بلاغ صيانة · استعرض الدليل — من أي مكان.',
    accent: '#1F7AE0',          // friendly approachable blue
    bg: '#F0F6FF',
    panel: '#1F7AE0',
    panelTextOn: '#FFFFFF',
    auth: { password: true, magicLink: true, otp: true },
    afterLogin: '/tenant',
    badge_en: 'Resident',
    badge_ar: 'مستأجر',
  },
  owner: {
    slug: 'owner',
    label_en: 'Property Owner',
    label_ar: 'مالك العقار',
    tagline_en: 'Executive dashboard · cash flow · NOI · AI insights · onboarding videos.',
    tagline_ar: 'لوحة تنفيذيّة · التدفّق النقدي · صافي الدخل · رؤى الذكاء الاصطناعي · فيديو الإرشاد.',
    accent: '#0E6E5C',          // calm executive teal
    bg: '#F7FAF8',
    panel: '#0E1320',
    panelTextOn: '#FFFFFF',
    auth: { password: true, magicLink: true, otp: false },
    afterLogin: '/owner-portal',
    badge_en: 'Owner',
    badge_ar: 'مالك',
  },
  vendor: {
    slug: 'vendor',
    label_en: 'Vendor · Contractor',
    label_ar: 'المورّد · المقاول',
    tagline_en: 'Accept work orders · upload photos · close the loop — from your phone.',
    tagline_ar: 'اقبل أوامر العمل · ارفع الصّور · أكمل الإجراء — من هاتفك.',
    accent: '#D97706',          // safety orange
    bg: '#FFF8EE',
    panel: '#7C3F00',
    panelTextOn: '#FFFFFF',
    auth: { password: false, magicLink: false, otp: true },  // mobile-first OTP only
    afterLogin: '/vendor-portal',
    badge_en: 'Vendor',
    badge_ar: 'مورّد',
  },
  investor: {
    slug: 'investor',
    label_en: 'Investor · LP',
    label_ar: 'المستثمر',
    tagline_en: 'Capital partners — portfolio returns · distribution history · institutional reports.',
    tagline_ar: 'شركاء رأس المال — عوائد المحفظة · سجلّ التوزيعات · تقارير مؤسّسيّة.',
    accent: '#A47148',          // burnished bronze — institutional luxe
    bg: '#FBFAF7',
    panel: '#1A1410',           // espresso black-brown
    panelTextOn: '#FFFFFF',
    auth: { password: true, magicLink: true, otp: false, preferMagic: true },  // executive-friendly magic-link first
    afterLogin: '/investor-portal',
    badge_en: 'Investor',
    badge_ar: 'مستثمر',
  },
};

export const PORTAL_KEYS = Object.keys(PORTALS);

export function getPortal(slug) {
  return PORTALS[slug] || PORTALS.manager;
}
